<template>
  <v-container class="bg-white pa-0 policeLato" fluid pt-5>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
      <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
      <section>
        <div class="mt-5 paralax-cover-image has-background-dim">
          <p class="paralax-cover-image-text">
          <div class="content_home" style="z-index: 1!important;">
            <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_assur_plus.header_title[0]') }}</span></h1>
            <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('devis.devis_assur_plus.header_title[1]') }}</span></h1>
          </div>
          </p>
        </div>
      </section>

      <v-layout class="column" style="margin-bottom: 3.5%">
        <v-layout style="background-color: #f5f6f6;">
          <v-flex xs12 style="padding-left: 8%;padding-right: 8%">
            <div class="justify-content-center row">
              <div class="pa-5 text-justify subheading font-weight-blod pl-md-5 pr-md-5" style="margin-bottom:-50px">
                <span class="headline" style="color: #ffa409"><i class="title-border policeLato"></i>{{ $t('devis.devis_assur_plus.title[0]') }}</span>
                <div class="container mt-4 mb-5">
                  <div class="justify-content-center row">
                    <div class="col-md-3">
                      <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);">
                        <div class="healthCard-img">
                          <img src="../../assets/img/img-sante/individu_accident.jpeg" alt="individuel-accident-product" class="img-responsive" />
                        </div>
                        <div class="healthCard-text">
                          <div class="category">
                            <button @click="toIndividuel" class="button_redirect">{{ $t('devis.devis_assur_plus.individuel_card.card_title') }}</button>
                          </div>
                          <div class="description-prod">
                            <p>{{ $t('devis.devis_assur_plus.individuel_card.card_content') }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);">
                        <div class="healthCard-img">
                          <img src="../../assets/img/img-sante/sonac_card.jpg" alt="sonac-product" class="img-responsive" />
                        </div>
                        <div class="healthCard-text">
                          <div class="category">
                            <button @click="toSonac" class="button_redirect">{{ $t('devis.devis_assur_plus.caution_card.card_title') }}</button>
                          </div>
                          <div class="description-prod">
                            <p>{{ $t('devis.devis_assur_plus.caution_card.card_content') }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <!--PARITE NEWSLETTER-->
            <div style="background: rgba(153,153,153,0.39);height: 120px" class="mb-5">
              <div class="row" style="margin-left: 10.5%">
                <div class="mt-5 justify-content-center row">
                  <h1 class="justify-content-center" style="color: #001b19;font-size: 25px;font-weight: bold;margin-top: 6%;text-align: center">{{$t('home_page.newsletter_title')}}</h1>
                  <a href="https://www.221assurances.com" target="_blank">
                <img class="mt-1 ml-4" src="../../assets/img/logos_sn_221.png" alt="logos_sn_221" style="width: 50px;cursor: pointer;">
                </a>
                </div>

                <div class="mt-5 justify-content-center row" style="width: 50%;margin-left: -3%">
                  <input v-model="UserEmail" type="email" name="email" id="email_input" :placeholder="$t('home_page.newsletter_input_placeholder')">
                </div>
                <div class="mt-5 justify-content-center row" style="margin-left: -5%">
                  <button style="height: 50px!important" flat class="newsletter ml-2" @click="suscribeNewsletter221()">
                    <span class="newsletter">{{$t('home_page.newsletter_bouton')}}</span>
                  </button>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <div class="payement">
      <MyFreeDevisButton></MyFreeDevisButton>
      <div class="">
        <img width="50" height="30" alt="logo" src="../../assets/img/logoPaiement/orange-money.png"/>
        <img width="60" height="30" alt="logo" src="../../assets/img/logoPaiement/freemoney.png"/>
        <img class="pt-1" width="60" height="25" alt="logo" src="../../assets/img/logoPaiement/visa.png"/>
        <img class="ml-1" width="60" height="30" alt="logo" src="../../assets/img/logoPaiement/master-card.png"/>
        <img class="ml-2" width="30" height="30" alt="logo" src="../../assets/img/logoPaiement/wave.png"/>
        <img class="ml-3" width="30" height="30" alt="logo-kpay" src="../../assets/img/logoPaiement/kpay_logo.webp"/>
      </div>
    </div>
            
          </v-flex>
        </v-layout>
      </v-layout>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.sm.xs>
      <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
      <section>
        <div class="paralax-cover-image_mobile has-background-dim_mobile">
          <p class="paralax-cover-image-text_mobile">
          <div class="content_home" style="z-index: 1!important;margin-top: 10%">
            <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_assur_plus.header_title[0]') }}</span></h1>
            <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('devis.devis_assur_plus.header_title[1]') }}</span></h1>
          </div>
          </p>
        </div>
      </section>

      <v-layout style="background-color: #f5f6f6;">
        <div class="pl-3 pr-3 pt-3 row">
          <div class="col-sm-11 pa-4 subheading font-weight-blod text-justify">
            <span class="headline" style="color: #ffa409"><i class="title-border policeLato"></i>{{ $t('devis.devis_assur_plus.title[0]') }}</span>
          </div>
        </div>
      </v-layout>

      <v-layout style="background-color: #f5f6f6;">
        <div class="pb-5">

          <div class="container">
            <div class="row">
              <div class="col-md-3">
                <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);">
                  <div class="healthCard-img">
                    <img src="../../assets/img/img-sante/individu_accident.jpeg" alt="individuel-accident-product" class="img-responsive" />
                  </div>
                  <div class="healthCard-text">
                    <div class="category">
                      <button @click="toIndividuel" class="button_redirect">{{ $t('devis.devis_assur_plus.individuel_card.card_title') }}</button>
                    </div>
                    <div class="description-prod">
                      <p>{{ $t('devis.devis_assur_plus.individuel_card.card_content') }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);">
                  <div class="healthCard-img">
                    <img src="../../assets/img/img-sante/sonac_card.jpg" alt="sonac-product" class="img-responsive" />
                  </div>
                  <div class="healthCard-text">
                    <div class="category">
                      <button @click="toSonac" class="button_redirect">{{ $t('devis.devis_assur_plus.caution_card.card_title') }}</button>
                    </div>
                    <div class="description-prod">
                      <p>{{ $t('devis.devis_assur_plus.caution_card.card_content') }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-layout>

      <!--PARITE NEWSLETTER-->
      <v-layout>
        <div style="background: rgba(153,153,153,0.39);height:auto;width: 100%">
          <div class="justify-content-center column">
            <div class="pt-5 justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">{{$t('home_page.newsletter_title')}}</h1>
            </div>

            <div class="justify-content-center row">
              <a href="https://www.221assurances.com" target="_blank">
                <img class="mt-3 mb-4" src="../../assets/img/logos_sn_221.png" alt="logos_sn_221" style="width: 50px;cursor: pointer;">
                </a>
            </div>

            <div class="mt-2 justify-content-center row">
              <input v-model="UserEmail" type="email" name="email" id="email_input" :placeholder="$t('home_page.newsletter_input_placeholder')">
            </div>

            <div class="justify-content-center row pb-5">
              <button style="height: 50px!important" flat class="newsletter ml-2" @click="suscribeNewsletter221()">
                <span class="newsletter">{{$t('home_page.newsletter_bouton')}}</span>
              </button>
            </div>
          </div>
        </div>
      </v-layout>

      <!--PARITE PAIEMENT-->
      <v-layout>
        <div class="payement">
      <MyFreeDevisButton></MyFreeDevisButton>
      <div class="">
        <img width="50" height="30" alt="logo" src="../../assets/img/logoPaiement/orange-money.png"/>
        <img width="60" height="30" alt="logo" src="../../assets/img/logoPaiement/freemoney.png"/>
        <img class="pt-1" width="60" height="25" alt="logo" src="../../assets/img/logoPaiement/visa.png"/>
        <img class="ml-1" width="60" height="30" alt="logo" src="../../assets/img/logoPaiement/master-card.png"/>
        <img class="ml-2" width="30" height="30" alt="logo" src="../../assets/img/logoPaiement/wave.png"/>
        <img class="ml-3" width="30" height="30" alt="logo-kpay" src="../../assets/img/logoPaiement/kpay_logo.webp"/>
      </div>
    </div>

      </v-layout>
    </div>
  </v-container>
</template>

<script>
import PushInDataLayer from '../../services/TagManager'
import store from "../../store/store";
import Api from "../../services/Api";

import DropdowAssurancePage from '../assurance_page_component/DropdowAssurancePage.vue';
import MyFreeDevisButton from '../../components/layouts/boutons/MyFreeDevisButton.vue';


export default {
  components: {
          MyFreeDevisButton
      },
  name: "Sante",
  data() {
    return {
      isHidden: true,
      description:'Assuraf – Tout savoir sur l’assurance Santé',
      ToastTabSucess: { // Customized options for success toast
        theme: "toasted-primary",
        position: "top-center",
        duration: 7000,
        fitToScreen: true,
        type: 'success',
        className: 'custom-success-class'
      },
      ToastTabError: { // Customized options for error toast
        theme: "toasted-primary",
        position: "top-center",
        duration: 7000,
        fitToScreen: true,
        type: 'error'
      },
      UserEmail: null,
    }
  },
  metaInfo () {
    return {
      meta: [
        { charset: 'utf-8' },
        { name: 'keywords', content: 'description, assurance sante'},
        { hid: 'description', name: 'description', content: this.description}
      ]
    }
  },
  methods: {
    toSonac(){
      this.$router.push('/devis/sonac')
    },
    toCnaas(){
      this.$router.push('/devis/cnaas')
    },
    toIndividuel(){
      this.$router.push('/individuel')
    },

    suscribeNewsletter221 () {
        if(this.UserEmail) {
          let newAbonne221 = {
            listIds: [23],
            email: this.UserEmail,
            updateEnabled: false
          }

          ApiBrevo().post('contacts', newAbonne221)
            .then(result => {
              console.log("result===== ", result)

              if (result.status === 201) {
                this.$toasted.show("Merci de votre inscription à notre newsletter 221 !", this.ToastTabSucess);
                this.UserEmail = ''
              }
            }).catch((err) => {
              console.log("err==== ", err)
              this.$toasted.show("Le mail saisit est déja inscrit dans notre newsletter", this.ToastTabError);
            }); 
        } else {
          this.$toasted.show("Un email valide est obligatoire pour souscrire à notre newsletter 221 !", this.ToastTabError);
        }        
        },

    abonnementnewsletter() {
      if (this.UserEmail) {
        if (store.state.isUserLoggedIn) {
          let newAbonne = {
            user: this.$store.state.user._id,
            etat: 'enabled',
            FNAME: this.$store.state.user.prenom,
            LNAME: this.$store.state.user.nom,
            PHONE: this.$store.state.user.telephone_port,
            email: this.UserEmail,
            dateAbone: dayjs(new Date()).format('YYYY-MM-DD')
          };

          Api().post('testimonial/mailchimp/newsletter', newAbonne)
              .then(res => {
                if (res.data.ret.statusCode == 200) {
                  Api().post('newsletter/add', newAbonne)
                      .then(resp => {
                        if (resp.data.msg)
                        {
                          const GtmVal = {
                            event:'newsletter_subscription'
                          }
                          PushInDataLayer(GtmVal)
                          this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                          this.UserEmail = ''
                        }
                      })
                }
              })
              .catch(e => {
                this.$toasted.show('Votre demande de souscription à la newsletter a échoué ', this.ToastTabError)
              })

        } else {

          let newAbonne = {
            user: "",
            etat: 'enabled',
            FNAME: "",
            LNAME: "",
            PHONE: "",
            email: this.UserEmail,
            dateAbone: dayjs(new Date()).format('YYYY-MM-DD')
          };

          Api().post('testimonial/mailchimp/newsletter', newAbonne)
              .then(res => {
                if (res.data.ret.statusCode == 200) {
                  Api().post('newsletter/add', newAbonne)
                      .then(resp => {
                        if (resp.data.msg)
                        {
                          const GtmVal = {
                            event:'newsletter_subscription'
                          }
                          PushInDataLayer(GtmVal)
                          this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                          this.UserEmail = ''
                        }
                      })
                }

              }).catch(e => {
            this.$toasted.show('Votre demande de souscription à la newsletter a échoué', this.ToastTabError)
          })
        }

      } else {
        this.$toasted.show('Veuillez renseigner votre adresse email ', this.ToastTabError)
      }
    },
    quote_creation_intent(position)
    {
      let GtmVal
      switch (position) {
        case 'top-btn':
          this.quoteCreationEntryPoint.entry_point = 'assur_page_top_button'
          GtmVal ={
            branche:'sante',
            entry_point :'assur_page_top_button',
            event:'quote_creation_intent'
          }
          break;
        case 'bottom-btn':
          this.quoteCreationEntryPoint.entry_point = 'assur_page_bottom_button'
          GtmVal ={
            branche:'sante',
            entry_point :'assur_page_bottom_button',
            event:'quote_creation_intent'
          }
          break;
      }
      PushInDataLayer(GtmVal)
    },

    isMobile: function () {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },

    isDesktop: function () {
      if (screen.width > 760) {
        return true;
      } else {
        return false;
      }
    },

    voirPlus: function () {
      this.isHidden = !this.isHidden;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    let GtmVal ={
      branche:'sante',
      event:'view_assur_page'
    }
    PushInDataLayer(GtmVal)
  }
}
</script>

<style scoped>
.text-assuraf {
  color: #ffa409;
  /* font-family: Georgia !important; */
  font-weight: bold;
}

.title-border {
  border-left: 5px solid #ffa409;
  padding-left: 0.6em;
  line-height: 0.5em;
}

.georgia {
  font-family: Georgia !important;
}

.espace {
  line-height: 30px;
}



.texte {
  width: auto;
  font-family: Lato, "Helvetica Neue", Arial, sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.details {
  height: 36px;
  width: 120px;
  border-radius: 30px;
}

.text-assuraf {
  color: #ffa409;
}

.Assurance-AutoMoto {
  width: auto;
  height: 36px;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

.border-radius {
  border-radius: 10px
}

.policeLato{
  font-family: Lato, "Helvetica Neue", Arial, sans-serif
}

















.expansion.expand-list{
  margin: 0;
  padding: 0;
}
.expansion.expand-list > li{
  list-style-type: none;
  padding: 15px 0;
  background-color: #fff;
  border-radius: 10px;
  position: relative;
  margin-top: 10%;
  /*         max-width: 80%; */
}
.expansion label[class^="tab"]:hover{
  cursor: pointer;
}
.expansion input{
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.expansion input[class^="tab"]{
  width: 100%;
  height: 40px;
  position: absolute;
  left: 0;
  top: 0;
}
.expansion input[class^="tab"]:hover{
  cursor: pointer;
}
.expansion label[class^="tab"]{
  font-weight: bold;
  font-size: 17px;
  margin-left: 3%;
}
.expansion .content{
  height: auto;
  max-height: 0;
  max-width: 400px;
  margin-left: 3%;
  font-weight: bold;
  /*        background: yellow;*/
  overflow: hidden;
  transform: translateY(20px);
  transition: all 180ms ease-in-out 0ms;
}
.expansion li[data-md-content="100"] input[class^="tab"]:checked ~ .content{
  max-height: 100px;
  transition: all 150ms ease-in-out 0ms;
}
.expansion li[data-md-content="200"] input[class^="tab"]:checked ~ .content{
  max-height: 200px;
  transition: all 200ms ease-in-out 0ms;
}
.expansion li[data-md-content="300"] input[class^="tab"]:checked ~ .content{
  max-height: 300px;
  transition: all 250ms ease-in-out 0ms;
}
.expansion li[data-md-content="400"] input[class^="tab"]:checked ~ .content{
  max-height: 400px;
  transition: all 250ms ease-in-out 0ms;
}
.expansion li[data-md-content="500"] input[class^="tab"]:checked ~ .content{
  max-height: 500px;
  transition: all 250ms ease-in-out 0ms;
}
.expansion li[data-md-content="600"] input[class^="tab"]:checked ~ .content{
  max-height: 600px;
  transition: all 250ms ease-in-out 0ms;
}
.expansion li[data-md-content="700"] input[class^="tab"]:checked ~ .content{
  max-height: 700px;
  transition: all 300ms ease-in-out 0ms;
}
.expansion li[data-md-content="800"] input[class^="tab"]:checked ~ .content{
  max-height: 800px;
  transition: all 300ms ease-in-out 0ms;
}
.expansion li[data-md-content="900"] input[class^="tab"]:checked ~ .content{
  max-height: 900px;
  transition: all 300ms ease-in-out 0ms;
}
.expansion li[data-md-content="1000"] input[class^="tab"]:checked ~ .content{
  max-height: 1000px;
  transition: all 350ms ease-in-out 0ms;
}
.expansion li[data-md-content=""] input[class^="tab"]:checked ~ .content{
  max-height: 1000px;
  transition: all 250ms ease-in-out 0ms;
}
.expansion input[class^="tab"]:checked ~ .content{
  margin-bottom: 20px;
}

.expansion .open-close-icon{
  display: inline-block;
  position: absolute;
  right: 20px;
  transform: translatey(2px);
}
.expansion .open-close-icon i{
  position: absolute;
  left: 0;
}
.expansion .open-close-icon .fa-chevron-up{
  transform:rotate(-180deg);
  transition: transform 150ms ease-in-out 0ms;
}
.expansion input[class^="tab"]:checked ~ .open-close-icon .fa-chevron-up{
  opacity: 1;
  transform: rotate(0deg);
  transition: transform 150ms ease-in-out 0ms;
}
.expansion .open-close-icon .fa-chevron-down{
  opacity: 0;
  transform:rotate(-90deg);
  transition: opacity 50ms linear 0ms, transform 150ms ease-in-out 0ms;
}
.expansion input[class^="tab"]:checked ~ .open-close-icon .fa-chevron-down{
  opacity: 0;
  transform: rotate(0deg);
  transition: opacity 50ms linear 0ms, transform 150ms ease-in-out 0ms;
}




.trigger_auto{
  width: 300px;
}
.trigger_auto span {
  width: 300px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}


.newsletter span{
  width: 200px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  text-transform: none;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border: 2px solid #000000;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}
.newsletter:hover span {
  /*min-width: 220px;*/
  border-radius: 10px;
  border: none;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #000000;
  background: #ffa409;
}


input[type="email"]{
  background: rgba(255, 255, 255, 0.1);
  border: none;
  font-size: 16px;
  height: auto;
  margin: 0;
  outline: 0;
  padding: 15px;
  width: 300px;
  background-color: rgba(115, 115, 115, 0.58);
  color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
  margin-bottom: 30px;
}
input[type="email"]::placeholder{
  color: #fff;
  font-size: 20px;
}



.trigger{
  width: 220px;
}
.trigger span {
  width: 220px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}
.trigger ul.devis li {
  top: 0;
  left: 0;
  width: 220px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}
.trigger ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right,#eee,#fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}
.trigger ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}
.trigger ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}
.trigger ul.devis li:hover {
  border-left: 10px solid #eee;
}
.trigger:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}
.watch_video:hover span {
  border-radius: 10px;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #000000;
  background: #ffa409;
}

.trigger:hover ul.devis {
  transform: scaley(1);
}
.trigger:hover ul.devis a {
  opacity: 1;
}



.trigger_auto_mobile{
  width: auto;
}
.trigger_auto_mobile span {
  width: auto;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.newsletter span{
  width: 200px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  text-transform: none;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border: 2px solid #000000;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}
.newsletter:hover span {
  border-radius: 10px;
  border: none;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #000000;
  background: #ffa409;
}







.paralax-cover-image {
  background-image: url('../../assets/img/assurance/assurPlus.jpg');
  position: relative;
  background-size: contain!important;
  background-position: 50%;
  min-height: 210px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  /*padding: 20px;*/
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
}

.paralax-cover-image .paralax-cover-image-text,
.paralax-cover-image h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image.has-background-dim:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image {
  background-attachment: fixed;
  background-position: 50% 50px;
}



.paralax-cover-image_mobile {
  background-image: url('../../assets/img/assurance/assurPlus_mobile.jpg');
  position: relative;
  background-size: contain;
  background-position: 50%;
  min-height: 150px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  /*padding: 20px;*/
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image_mobile p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  padding-bottom: 20Px;
}

.paralax-cover-image_mobile .paralax-cover-image-text_mobile,
.paralax-cover-image_mobile h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image_mobile.has-background-dim_mobile:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image_mobile {
  /* background-attachment: fixed; */
  background-position: 100% 40px;
}


.hero {
  position: relative;
  background-size: cover;
  background-position: center center;
  height: 680px;
  min-height: 320px;
  max-height: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -ms-flex-pack: center;
  padding: 20px;
}
.hero .content_home {
  position: relative;
  min-height: 280px;
  width: 100%;
  margin-left: 8.5%;
  z-index: 2;
  /*//background: red;*/
}
.hero .content_home p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.healthCard-product{
  background:#fff;
  padding:15px;
  border-radius:6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  position:relative;
  margin:20px auto;
}
.healthCard-img{
  position:absolute;
  top:5px;
  left:50%;
  transform:translate(-50%);
  -webkit-transform:translate(-50%);
  -ms-transform:translate(-50%);
  -moz-transform:translate(-50%);
  -o-transform:translate(-50%);
  -khtml-transform:translate(-50%);
  width: 100%;
  padding: 15px;
  transition: all 0.2s ease-in-out;
}
.healthCard-img img{
  width:100%;
  transition: all 0.2s ease-in-out;
  border-radius:6px;
}
.healthCard-text{
  padding-top:68%;
}
.healthCard-text .category{
  text-align:center;
  font-size:12px;
  font-weight:bold;
  padding:5px;
  margin-bottom:45px;
  position:relative;
  transition: all 0.2s ease-in-out;
}
.healthCard-text .category > *{
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  -webkit-transform: translate(-50%,-50%);
  -moz-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  -o-transform: translate(-50%,-50%);
  -khtml-transform: translate(-50%,-50%);

}
.healthCard-text .category > span{
  width: max-content;
  padding: 12px 30px;
  border: 1px solid #ffa409;
  background:#ffa409;
  color:#fff;
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  border-radius:27px;
  transition: all 0.05s ease-in-out;

}
.healthCard-text .category > .button_redirect {
  width: max-content!important;
  width: -moz-max-content!important;
  display: inline-block!important;
  padding: 12px 30px;
  border: 1px solid #ffa409;
  background:#ffa409;
  color:#fff;
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  border-radius:27px;
  transition: all 0.05s ease-in-out;
}

.healthCard-text .category > .button_redirect_disabled {
  width: max-content!important;
  width: -moz-max-content!important;
  display: inline-block!important;
  padding: 12px 30px;
  border: 1px solid #59595B;
  background:#59595B;
  color:#fff;
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  border-radius:27px;
  transition: all 0.05s ease-in-out;
}

.healthCard-product:hover .healthCard-text .category > span{
  border-color:#ddd;
  box-shadow: none;
  padding: 11px 28px;
}
.healthCard-text .title-product h3{
  font-size:20px;
  font-weight:bold;
  margin:15px auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width:100%;
}
.healthCard-text .description-prod p{
  margin:0;
}
.healthCard-text .description-prod {
  width: 100%;
  height:130px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  margin-bottom:15px;
}

@media screen and (max-width: 991px) {
  .healthCard-product{
    margin:40px auto;
  }
  .healthCard-product .healthCard-img{
    top:-40px;
  }
  .healthCard-product .healthCard-img img{
    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  }
  .healthCard-product .healthCard-text .category > span{
    border-color:#ddd;
    box-shadow: none;
    padding: 11px 28px;
  }
  .healthCard-product .healthCard-text .category{
    margin-top: -55px;
  }
}

.payement {
  display: flex;
  justify-content: space-between;
  padding: 0px 8%;
}
@media screen and (max-width: 700px) {
  .payement {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    padding: 25px 0;
  }
}
</style>
